function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 4,
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 3.5,
  stroke: "currentColor",
  strokeOpacity: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8661 13.6315C12.7704 13.7273 12.6562 13.8026 12.5306 13.853L10.7631 14.56C10.5813 14.6327 10.3822 14.6505 10.1905 14.6112C9.99874 14.5719 9.82275 14.4771 9.68433 14.3387C9.54592 14.2003 9.45117 14.0243 9.41184 13.8326C9.3725 13.6408 9.39031 13.4417 9.46305 13.26L10.1706 11.4925C10.2207 11.3667 10.2959 11.2524 10.3916 11.1565L13.8001 7.75H7.78605C7.37279 7.7504 6.97656 7.91471 6.68429 8.20688C6.39202 8.49906 6.22758 8.89524 6.22705 9.3085V16.1915C6.22771 16.6047 6.39219 17.0008 6.68443 17.293C6.97667 17.5851 7.37283 17.7495 7.78605 17.75H14.6686C15.0817 17.7495 15.4778 17.5851 15.77 17.2929C16.0622 17.0008 16.2265 16.6047 16.2271 16.1915V10.2705L12.8661 13.6315Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0665 6.54252L10.922 11.687C10.8982 11.7111 10.8793 11.7396 10.8665 11.771L10.1595 13.5385C10.1413 13.584 10.1369 13.6339 10.1467 13.6819C10.1566 13.7299 10.1803 13.7739 10.215 13.8085C10.2499 13.8426 10.2939 13.866 10.3417 13.8757C10.3895 13.8855 10.4391 13.8813 10.4845 13.8635L12.25 13.1565C12.2815 13.1439 12.3101 13.125 12.334 13.101L17.48 7.95702C17.5756 7.86481 17.6518 7.75449 17.7043 7.6325C17.7567 7.51052 17.7843 7.37931 17.7855 7.24653C17.7867 7.11375 17.7615 6.98206 17.7113 6.85915C17.661 6.73623 17.5868 6.62456 17.4929 6.53063C17.3991 6.43671 17.2875 6.36241 17.1646 6.31209C17.0417 6.26176 16.91 6.23642 16.7773 6.23752C16.6445 6.23863 16.5132 6.26617 16.3912 6.31853C16.2692 6.3709 16.1588 6.44704 16.0665 6.54252Z",
  fill: "white"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6a9b0cf8.svg";
export { ForwardRef as ReactComponent };